import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteKiloClass, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCancelAthleteClass(): UseMutationResult<
  AxiosResponse<null | AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const cancelAthleteClass = (
    athleteKiloClassId: string,
  ): Promise<AxiosResponse<null | AthleteKiloClass>> => {
    return client.post(`athlete-kilo-classes/${athleteKiloClassId}/cancel/`);
  };

  return useMutation(cancelAthleteClass, {
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['athleteClasses'] });
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['classes'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
